// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"842894ab","821":"2b60c339"}[chunkId] + ".chunk.js";
};